<div class="">
    <div class="single_grid">
        <div class="grid images_3_of_2">
            <a href="optionallink.html">
                <img class="etalage_thumb_image" [src]="hdpe.avatar | async" style="display: inline; width: 300px; height: 400px; opacity: 1;">
            </a>
            <div class="clearfix"> </div>
        </div>
        <div class="desc1 span_3_of_2">
            <h1>{{hdpe.name}}</h1>
            <div class="cart-b">
                <div class="left-n ">$329.58</div>
                <a class="now-get get-cart-in" href="#">Liên Hệ Báo Giá</a>
                <div class="clearfix"></div>
            </div>
            <h6>100 items in stock</h6>
            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute
                irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.</p>
            <div class="share">
                <h5>Share Product :</h5>
                <ul class="share_nav">
                    <li>
                        <a href="#"><img src="images/facebook.png" title="facebook"></a>
                    </li>
                    <li>
                        <a href="#"><img src="images/twitter.png" title="Twiiter"></a>
                    </li>
                    <li>
                        <a href="#"><img src="images/rss.png" title="Rss"></a>
                    </li>
                    <li>
                        <a href="#"><img src="images/gpluse.png" title="Google+"></a>
                    </li>
                </ul>
            </div>
        </div>
        <div class="clearfix"> </div>
    </div>

    <h3 class="m_3">Giới Thiệu Sản Phẩm</h3>
    <p class="m_text">{{hdpe.intro}}</p>
    <!-- grids_of_4 -->
    <h3 class="m_3">Các Dòng Sản Phẩm của {{hdpe.name}}</h3>
    <div class="row grid-product">
        <div *ngFor="let brands of brand" class="col-3 content_box">
            <a [routerLink]="['/list-menu-product']" [queryParams]="{ id1: id, id2: brands.key }"><img class="img-thumbnail img-responsive chain" [src]="brands.avatar | async" alt=" " /></a>
            <span class="star"> </span>
            <div class="grid-chain-bottom">
                <h6><a [routerLink]="['/list-menu-product']" [queryParams]="{ id1: id, id2: brands.key }">{{brands.name}}</a></h6>
            </div>

            <div class="star-price">
                <div class="dolor-grid">
                    <span class="actual">300$</span>
                    <span class="reducedfrom">400$</span>
                </div>
                <a class="now-get get-cart" href="#">Chi Tiết</a>
            </div>
        </div>
        <div class="clearfix"> </div>
    </div>
</div>